import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AuthService } from 'src/app/services/auth.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.scss']
})
export class ForgetPasswordComponent implements OnInit {
  
  resetMail = ""

  constructor(public auth:AuthService,public router:Router,public common:CommonService,public messageService:MessageService) { }

  ngOnInit(): void {
  }

  resetPassword(formData){
    this.common.showLoader()
    this.auth.resetPassword(formData.value).subscribe(res=>{
      //console.log(res)
      this.common.stopLoader()
      // this.auth.logoutWithoutRedirect()
      //this.messageService.add({severity:'success', summary:'Reset Password Email Sent', detail:"Please check your email"});
      this.router.navigateByUrl("/reset-email-sent")
    },err=>{
      //console.log(err)
      this.messageService.add({severity:'error', summary:'Please enter a valid email!', detail:""});
      this.common.stopLoader()
    })
  }

}
